// import errorMessage from '../common/functions/message';
import {
    showLoading,
    hideLoading
} from '../common/functions/loading';

/* const warnPropRewrite = (msg) => {
  if (process && process.env && process.env.NODE_ENV && process.env.NODE_ENV === 'development') {
    console.warn(`[interceptors.js - Response REWRITE] ${msg}`); // eslint-disable-line
  }
};*/

const setHeaders = (request) => {

    request.headers.set('Authorization', `Bearer ${localStorage.getItem('token')}`);
    // request.headers.set('Authorization', `Basic -u pk_c5a1385205ec4a15986ce00545527675:`);
    request.headers.set('Accept', 'application/json');
    request.headers.set('Content-type', 'application/json');
    request.headers.set('Access-Control-Allow-Origin', 'true');
};

export default (Vue) => {
    Vue.http.interceptors.push((request, next) => {
        setHeaders(request);
        showLoading();
        next((response) => {
            hideLoading();
            return response;
        });
    });
};


// WEBPACK FOOTER //
// ./src/config/interceptors.js